import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import * as actions from '../actions';

export default function useActions() { 
    const dispatch = useDispatch();
    
    return bindActionCreators(actions, dispatch);
}